import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Alert from '@material-ui/lab/Alert';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import EuroOutlinedIcon from '@material-ui/icons/EuroOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import CandidatoService from '../../services/Candidato';
import { errors } from '../../services/API';

import Title from '../../components/Title/Title';
import Text from '../../components/Inputs/Text/Text';
import Toast from "../../components/Toast/Toast";
import Loading from '../../components/Loading/Loading';

import Endereco from '../../forms/Endereco/Endereco';

import { ButtonSecondary } from '../../components/Button/Button';
import { ButtonSave } from '../../forms/Buttons/ButtonsForm';

import {
    isBlank,
    isBlankHelperText,
    isNomeFaturadorInvalid,
    isNomeFaturadorHelperText,
    isCPFInvalid,
    isCPFHelperText,
    isCNPJInvalid,
    isCNPJHelperText,
    isMailInvalid,
    isMailHelperText,
} from '../../helper/ValidationHelper';
import { cpfMask, cnpjMask } from '../../helper/MaskHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';

import { Layout } from '../../layouts/private/Private';
import { isPeriodoPagamento } from '../../helper/ContextHelper';

export class DadosFatura extends Component {
    constructor(props) {
        super(props);
        this.state = {
            candidato: {
                pagamentoEmAndamento: false,
                pagamentoConfirmado: false,
            },
            fatura: {
                candidato: this.props.match.params.id,
                nome: '',
                cpfOuCnpj: "CPF",
                cpf: '',
                cnpj: '',
                email: '',
            },
            errors: {
                cpf: false,
                cnpj: false,
                nome: false,
                email: false,
            },
            helpers: {
                cpf: null,
                cnpj: null,
                nome: null,
                email: null,
            },
            loadingButtonSave: false,
            loading: this.props.match.params.id ? true : false,
            history: {
                path: null,
                state: null
            }
        };
    }

    // INPUTS
    handleChange = async e => {
        this.setState({
            fatura: {
                ...this.state.fatura,
                [e.target.name]: e.target.name === 'cpf' ? cpfMask(e.target.value) : e.target.name === 'cnpj' ? cnpjMask(e.target.value) : e.target.value
            },
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: false }
        });
    };

    resetaFormulario = e => {
        this.setState({
            fatura: {
                candidato: this.state.fatura.candidato,
                nome: this.state.fatura.nome, 
                email : "",
                cpf: "",
                cnpj: "",
                cpfOuCnpj : e.target.value
            },
            loading: false
        });
    };

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;
    setEndereco = e => this.Endereco = e;

    // VALIDAÇÕES
    isValid = () => {
        if (((isBlank(this.state.fatura.cpf) || isCPFInvalid(this.state.fatura.cpf)) && this.state.fatura.cpfOuCnpj === "CPF") 
                || ((isBlank(this.state.fatura.cnpj) || isCNPJInvalid(this.state.fatura.cnpj)) && this.state.fatura.cpfOuCnpj === "CNPJ") 
                || isBlank(this.state.fatura.nome) || isNomeFaturadorInvalid(this.state.fatura.nome) || isBlank(this.state.fatura.email) || isMailInvalid(this.state.fatura.email)) {
            this.setState({
                errors: {
                    cpf: (isBlank(this.state.fatura.cpf) || isCPFInvalid(this.state.fatura.cpf)) && this.state.fatura.cpfOuCnpj === "CPF" ? true : false,
                    cnpj: (isBlank(this.state.fatura.cnpj) || isCNPJInvalid(this.state.fatura.cnpj)) && this.state.fatura.cpfOuCnpj === "CNPJ" ? true : false,
                    nome: isBlank(this.state.fatura.nome) || isNomeFaturadorInvalid(this.state.fatura.nome) ? true : false,
                    email: isBlank(this.state.fatura.email) || isMailInvalid(this.state.fatura.email) ? true : false,
                },
                helpers: {
                    cpf: this.state.fatura.cpfOuCnpj === "CPF" ? isBlank(this.state.fatura.cpf) ? isBlankHelperText() : isCPFInvalid(this.state.fatura.cpf) ? isCPFHelperText() : null : null,
                    cnpj: this.state.fatura.cpfOuCnpj === "CNPJ" ? isBlank(this.state.fatura.cnpj) ? isBlankHelperText() : isCNPJInvalid(this.state.fatura.cnpj) ? isCNPJHelperText() : null : null,
                    nome: isBlank(this.state.fatura.nome) ? isBlankHelperText() : isNomeFaturadorInvalid(this.state.fatura.nome) ? isNomeFaturadorHelperText() : null,
                    email: isBlank(this.state.fatura.email) ? isBlankHelperText() : isMailInvalid(this.state.fatura.email) ? isMailHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    // SALVAR
    handleSubmit = async () => {
        this.setState({ loadingButtonSave: true });

        const formIsValid = this.isValid();
        const formEnderecoIsValid = this.Endereco.isValid();
        
        if (!formIsValid || !formEnderecoIsValid) {
            this.setState({ loadingButtonSave: false });
            return
        }

        const fatura = {
            cpf: this.state.fatura.cpfOuCnpj === "CPF" ? this.state.fatura.cpf : null,
            cnpj: this.state.fatura.cpfOuCnpj === "CNPJ" ? this.state.fatura.cnpj : null,
            nome: this.state.fatura.nome.toUpperCase().trim().replaceAll(/\s+/g, " "),
            email: this.state.fatura.email.trim().replaceAll(/\s+/g, " "),

            cep: this.Endereco.state.address.zipCode,
            endereco: this.Endereco.state.address.address.toUpperCase().trim(),
            numero: this.Endereco.state.address.number,
            complemento: this.Endereco.state.address.complement,
            bairro: this.Endereco.state.address.district.toUpperCase().trim(),
            municipio: this.Endereco.state.address.city,
        }

        CandidatoService.salvarDadosFatura(this.state.fatura.candidato, fatura)
            .then(resultado => {
                window.location.href = resultado.data;
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingButtonSave: false }))
    }

    async componentDidMount() {
        this.props.loadPeriodos();

        this.setState({ history: filterPersistence(this.props.location) });

        if (this.state.fatura.candidato) { 
            CandidatoService.find(this.state.fatura.candidato)
                .then(res => {
                    const candidato = res.data;

                    if (!candidato.precisaRealizarPagamento) {
                        this.Toast.setState({
                            message: {
                                message: "Não é necessário Realizar o Pagamento.",
                                type: 'error',
                                open: true
                            }
                        });

                        setTimeout(() => this.handleBack(), 2000);
                        return;
                    }

                    this.setState({
                         candidato: {
                            pagamentoEmAndamento: candidato.pagamentoEmAndamento,
                            pagamentoConfirmado: candidato.pagamentoConfirmado,
                        },
                        fatura: {
                            candidato: candidato.id,
                            nome: candidato.pagamento ? candidato.pagamento.fatura.nome : candidato.nomeExibicao,
                            email: candidato.pagamento ? candidato.pagamento.fatura.email : candidato.email,
                            cpfOuCnpj: candidato.pagamento ? candidato.pagamento.fatura.cpf ? "CPF" : "CNPJ" : "CPF",
                            cpf: candidato.pagamento && candidato.pagamento.fatura.cpf ? cpfMask(candidato.pagamento.fatura.cpf) : cpfMask(candidato.cpf),
                            cnpj: candidato.pagamento && candidato.pagamento.fatura.cnpj ? cnpjMask(candidato.pagamento.fatura.cnpj) : '',
                        },
                        loading: false
                    });                    
                    
                    if (candidato.pagamento) {
                        this.Endereco.findCities(candidato.pagamento.fatura.endereco.municipio.uf.id, candidato.pagamento.fatura.endereco.municipio.codigo);
                        this.Endereco.setState({
                            address: {
                                zipCode: candidato.pagamento.fatura.endereco.cep,
                                address: candidato.pagamento.fatura.endereco.endereco,
                                number: candidato.pagamento.fatura.endereco.numero,
                                complement: candidato.pagamento.fatura.endereco.complemento,
                                district: candidato.pagamento.fatura.endereco.bairro,
                                city: candidato.pagamento.fatura.endereco.municipio.codigo,
                                UF: candidato.pagamento.fatura.endereco.municipio.uf.id,
                            }
                        })
                    } else {
                        this.Endereco.findCities(candidato.endereco.municipio.uf.id, candidato.endereco.municipio.codigo);
                        this.Endereco.setState({
                            address: {
                            zipCode: candidato.endereco.cep,
                            address: candidato.endereco.endereco,
                            number: candidato.endereco.numero,
                            complement: candidato.endereco.complemento,
                            district: candidato.endereco.bairro,
                            city: candidato.endereco.municipio.codigo,
                            UF: candidato.endereco.municipio.uf.id,
                            },
                        });
                    }
                })
                .catch(err => {
                    this.Toast.setState({
                        message: {
                            message: "Não Foi Possível Buscar os Dados de Pagamento.",
                            type: 'error',
                            open: true
                        }
                    })

                    this.setState({ loading: false })
                })
        }
    }

    handleBack = () => {
        this.props.history.push({
            pathname: `${this.state.history.path}`,
            state: {
                history: {
                    state: this.state.history.state
                }
            }
        });
    }

    render() {
        const page = 'Confirmação de Dados da Fatura (Nota Fiscal)';

        const isPodeEditarDados = isPeriodoPagamento(this.props.contexts) && !this.state.candidato.pagamentoEmAndamento && !this.state.candidato.pagamentoConfirmado;

        return (
            <Layout>
                <Toast parentRef={this.setToast} />

                <Title>{page}</Title>
                <Title variant="h6">{this.state.fatura.nome}</Title>

                {this.state.loading ?
                    <Loading />
                :
                    <>
                        <Grid container >
                            <Grid item sm={12} lg={8}>
                                <Alert severity="warning">
                                    Confira os dados de pagamento abaixo e, se necessário, faça as alterações desejadas. Caso os dados de <b>Nota Fiscal</b> sejam de uma Pessoa Jurídica, selecione 
                                    a opção <b>CNPJ</b> no campo “Tipo de Faturador” e preencha seus dados.
                                </Alert>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={4} lg={4}>
                                <FormControl component="div" style={{ marginTop: 20, display: 'flex', flexDirection: 'row' }}>
                                    <FormLabel style={{ alignSelf: 'center', marginRight: 20 }} required component="legend" >Tipo de Faturador:</FormLabel>
                                    <RadioGroup
                                        row
                                        required
                                        aria-label="Tipo de Faturador"
                                        name="cpfOuCnpj"
                                        value={this.state.fatura.cpfOuCnpj}
                                        onChange={(e) => {this.handleChange(e); this.resetaFormulario(e);}}
                                    >
                                        <FormControlLabel style={{ marginRight: 30 }} value="CPF" control={<Radio />} label="Pessoa Física" />
                                        <FormControlLabel style={{ marginRight: 30 }} value="CNPJ" control={<Radio />} label="Pessoa Jurídica" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            { this.state.fatura.cpfOuCnpj === "CPF" ?
                                <Grid item lg={2}>
                                    <Text
                                        required
                                        name="cpf"
                                        label="CPF"
                                        value={this.state.fatura.cpf}
                                        error={this.state.errors.cpf}
                                        onChange={this.handleChange}
                                        helperText={this.state.helpers.cpf}
                                    />
                                </Grid>
                            : null }
                            
                            { this.state.fatura.cpfOuCnpj === "CNPJ" ?
                                <Grid item lg={2}>
                                    <Text
                                        required
                                        name="cnpj"
                                        label="CNPJ"
                                        value={this.state.fatura.cnpj}
                                        error={this.state.errors.cnpj}
                                        onChange={this.handleChange}
                                        helperText={this.state.helpers.cnpj}
                                    />
                                </Grid> 
                            : null }
                    
                            <Grid item sm={5} lg={5}>
                                <Text
                                    required
                                    name="nome"
                                    label="Nome do Faturador"
                                    value={this.state.fatura.nome}
                                    error={this.state.errors.nome}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.nome}
                                />
                            </Grid>

                            <Grid item sm={5} lg={5}>
                                <Text
                                    required
                                    name="email"
                                    label="E-mail do Faturador"
                                    value={this.state.fatura.email}
                                    error={this.state.errors.email}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.email}
                                />
                            </Grid>
                        </Grid>

                        <Endereco parentRef={this.setEndereco} />
                        
                        <Grid container spacing={3} alignItems='flex-end' style={{ marginTop: 16 }}>
                            <Grid item sm={12} lg={12}>
                                <ButtonSave
                                    startIcon={<EuroOutlinedIcon />}
                                    onClick={this.handleSubmit}                        
                                    name="Ir para o Pagamento. ATENÇÃO: Confirme se os dados estão corretos, pois serão os mesmos da Nota Fiscal"
                                    loading={this.state.loadingButtonSave}
                                    saveDisabled={!isPodeEditarDados}
                                />
                            </Grid>
                            <Grid item sm={12} lg={12}>
                                <ButtonSecondary
                                    startIcon={<ArrowBackIcon />}
                                    style={{ margin: 4 }}
                                    onClick={this.props.history.goBack}
                                    name={"Voltar"}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            </Layout>
        )
    }
};

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DadosFatura));